import type { OnboardingAction } from "@/lib/agent/types";
import { CreditCard, ExternalLink, MessageCircle } from "lucide-react";

interface ActionCardProps {
  action: OnboardingAction;
  onPayment: () => Promise<void>;
}

export function ActionCard({ action, onPayment }: ActionCardProps) {
  if (action === "show_payment") {
    return (
      <div data-testid="payment-card" className="agent-animate-fade-up ml-10">
        <div className="agent-animate-pulse-glow rounded-2xl border-2 border-black bg-black p-6 text-white shadow-[6px_6px_0px_0px_#FFD700]">
          <div className="mb-3 flex items-center gap-2">
            <CreditCard size={18} className="text-[#FFD700]" strokeWidth={3} />
            <p className="text-xs font-bold uppercase tracking-widest text-[#FFD700]">
              Cohort Program
            </p>
          </div>
          <p className="mb-1 text-3xl font-black uppercase">300 EUR</p>
          <p className="mb-5 text-sm opacity-70">100 EUR/month x 3 months</p>
          <button
            data-testid="subscribe-button"
            onClick={onPayment}
            className="w-full rounded-xl bg-[#FFD700] py-4 text-lg font-black text-black transition-transform hover:-translate-y-1 active:translate-y-0"
          >
            SUBSCRIBE NOW
          </button>
        </div>
      </div>
    );
  }

  if (action === "show_chickytutor") {
    return (
      <div data-testid="chickytutor-card" className="agent-animate-fade-up ml-10">
        <div className="rounded-2xl border-2 border-black bg-[#FFD700] p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
          <div className="mb-3 flex items-center gap-2">
            <ExternalLink size={18} strokeWidth={3} />
            <p className="text-xs font-bold uppercase tracking-widest">Try ChickyTutor</p>
          </div>
          <p className="mb-2 text-xl font-black">Practice speaking in 70+ languages</p>
          <p className="mb-5 text-sm font-bold">
            Use coupon{" "}
            <span className="rounded-lg bg-black px-2 py-0.5 text-xs tracking-wider text-[#FFD700]">
              LEARN33
            </span>
          </p>
          <a
            data-testid="chickytutor-link"
            href="https://chickytutor.com?utm_campaign=emergent"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-xl bg-black py-4 text-center text-lg font-black text-[#FFD700] transition-transform hover:-translate-y-1 active:translate-y-0"
          >
            VISIT CHICKYTUTOR
          </a>
        </div>
      </div>
    );
  }

  if (action === "show_whatsapp") {
    return (
      <div data-testid="whatsapp-card" className="agent-animate-fade-up ml-10">
        <div className="rounded-2xl border-2 border-black bg-emerald-500 p-6 text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
          <div className="mb-3 flex items-center gap-2">
            <MessageCircle size={18} strokeWidth={3} />
            <p className="text-xs font-bold uppercase tracking-widest">Talk To Founders</p>
          </div>
          <p className="mb-4 text-xl font-black">Have questions? Chat with us directly.</p>
          <a
            data-testid="whatsapp-link"
            href="https://chat.whatsapp.com/LKnFtZyBq86E4KuJw2Iiov?mode=gi_c"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-xl border-2 border-black bg-white py-4 text-center text-lg font-black text-emerald-600 transition-transform hover:-translate-y-1 active:translate-y-0"
          >
            JOIN WHATSAPP
          </a>
        </div>
      </div>
    );
  }

  if (action === "complete") {
    return (
      <div data-testid="complete-card" className="agent-animate-fade-up ml-10">
        <div className="rounded-2xl border-2 border-black bg-[#FFD700] p-6 text-center shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
          <p className="mb-2 text-2xl font-black uppercase">All Set</p>
          <p className="text-base font-medium">Thanks for chatting with Chicky. See you soon.</p>
        </div>
      </div>
    );
  }

  return null;
}
